import * as React from 'react';
import { Check, Visibility } from "@mui/icons-material";
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import { useLocation, useNavigate } from "react-router-dom";
import {
    Alert,
    Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    Fade, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputAdornment, InputLabel, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, MenuItem, Paper, Popover, Radio, RadioGroup, Select, Snackbar, Stack, Switch, TextField, Tooltip, Typography
} from "@mui/material";
import Service from '../../../../util/Service';
// import { parseJSON } from 'jsgantt-improved';

export default function BuscaListaDialog(props) {
    const { onClose, refDiv, open, clonedContent, element, onSelect,
        closePai, refreshEditor } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [bannerOpen, setBannerOpen] = React.useState(false);
    const [jsonTxt, setJsonTxt] = React.useState('');
    const [urlApi, setUrlApi] = React.useState();
    const [interno, setInterno] = React.useState(false);
    const [tipo, setTipo] = React.useState('lista');

    const [apiLocal, setApiLocal] = React.useState([]);

    const [caminho, setCaminho] = React.useState();
    const [uri, setURI] = React.useState('');

    const [msg, setMsg] = React.useState();
    const [openSnack, setOpenSnack] = React.useState(false);

    const [value, setValue] = React.useState('sem');
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setMsg();
        setOpenSnack(false);
    };

    const closeBanner = () => {
        setBannerOpen(false);
    };

    const handleClose = () => {
        onClose();
        closePai();
    };
    const handleInferir = () => {
        console.log(caminho);
        const j = JSON.parse(jsonTxt);
        console.log(j);

        const ret = eval('j.' + caminho);
        console.log(ret)
        if (!ret) {
            alert('Caminho indisponível: ' + caminho)
        } else {
            if (ret.length) {
                setTipo('lista')
            } else {
                setTipo('campos')
            }
            console.log(typeof ret);
        }
    }
    const geraPagina = () => {
        const remove = document.createElement('p');
        remove.setAttribute("id", "paraRemover");
        remove.textContent = "---";
        clonedContent.replaceWith(remove);
        const el = document.getElementById("very2Editor");
        let html = '';
        const htmlOld = refDiv.current.innerHTML;
        if (!el) {
            html = refDiv.current.innerHTML;
        } else {
            html = el.innerHTML;
        }
        const dado = {
            urlApi: urlApi,
            interno: interno,
            uri: uri,
            caminho: caminho,
            code: html,
            paginacao: value,
            tipo: tipo
        }
        Service.POST("/api/security/model/buscaLista", dado).then(r => {
            console.log(r);
            if (r.success) {
                refDiv.current.innerHTML = r.dado;
                onClose();
                closePai();
                refreshEditor();
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                refDiv.current.innerHTML = htmlOld;
            }
        })
    };
    const MontaTipo = () => {
        if (tipo === 'campos') {
            return (
                <Stack>
                    <p>Dados de tipo campos, listar os campos é a forma ideal para esse tipo de dado.</p>
                    <Button>Defini campos</Button>
                </Stack>
            )

        }else if (tipo === 'lista') {
            return (
                <Stack>
                    <div>
                        <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label">Paginação</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="paginacao"
                                value={value}
                                onChange={handleChange}
                            >
                                <FormControlLabel value="sem" control={<Radio />} label="Sem paginação" />
                                <FormControlLabel value="front" control={<Radio />} label="Papinação no front" />
                                <FormControlLabel value="back" control={<Radio />} label="Paginação no back" />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <div style={{ fontSize: '12px' }}>
                        <p>Opção da paginação</p>
                        <ul>
                            <li><b>Sem paginação</b> Ideal para tabelas inferiores a 100 registros</li>
                            <li><b>Paginação no front</b> Ideal para quantidade media de registros maior do que 100 porem não superior a 10.000 registros. Ideal analisar o tempo de busca para não deixar ultrapassa 300ms</li>
                            <li><b>Paginação back</b> Ideal para grande quantidade de dados</li>
                        </ul>
                    </div>
                </Stack>
            )
        }
        return (
            <p>não definido!!!</p>
        )
    }
    const onChangeLocalApi = (e) => {
        if (e.target.checked) {
            Service.GET("/api/bpmn/buscaTodosAtivos").then(r => {
                if (r && r.length > 0) {
                    let list = [];
                    for (let x in r) {
                        const bpm = r[x];
                        list.push({
                            nome: bpm.nome,
                            value: "/api/bpmn/onLine/" + bpm.nome
                        })

                    }
                    setApiLocal(list);
                    console.log("onChangeLocalApi: ", list);
                    setUrlApi('');
                }
            }).catch(er => {
                console.log(er)
            })
            if (!caminho) setCaminho('dado[0].body[0].dado.result');
        }
        setInterno(e.target.checked);
    }
    const onChangeSelectApi = (e) => {
        console.log(e.target);
        setUrlApi(e.target.value);
    }
    const handleSeeAPI = () => {
        if (!urlApi || urlApi.length == 0) return;

        if (bannerOpen) {
            closeBanner();
            return;
        }
        const dado = {
            urlApi: urlApi,
        }
        if (interno) {
            dado.urlApi += "?" + uri;
        }
        Service.POST("/api/security/model/geraCabecalhoAPI", dado).then(r => {
            if (r.success) {
                const jsonString = JSON.stringify(r.dado, null, 2);
                setJsonTxt(jsonString);
            } else {
                setOpenSnack(true);
                setMsg(r.msg)
            }
        }).catch(er => {
            console.log(er);
            if (er.status === 401) {
                localStorage.setItem("localStorage", location.pathname);
                navigate("/login");
            }
        })
        setBannerOpen(true)
    }
    return (
        <Dialog
            onClose={handleClose}
            open={open}
            fullWidth
            maxWidth='sm'
        >
            <DialogTitle>
                <Stack direction="row" spacing={1}>
                    <Typography variant='body'>
                        API
                    </Typography>
                    <FormControlLabel
                        sx={{ mt: 1 }}
                        control={
                            <Switch
                                checked={interno}
                                onChange={onChangeLocalApi}
                            />
                        }
                        label="Interno"
                    />
                    {!interno && <TextField
                        label="API"
                        size='small'
                        fullWidth
                        // variant="outlined"
                        value={urlApi || ""}
                        onChange={(e) => setUrlApi(e.target.value)}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            edge="end"
                                            color={urlApi && urlApi.length > 0 ? 'primary' : 'inherit'}
                                            onClick={handleSeeAPI}
                                        >
                                            <Visibility />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            },
                        }}
                    />}
                    {interno &&
                        <Stack direction="row">
                            <FormControl fullWidth sx={{ mt: 2, minWidth: 120, width: "300px" }}
                                size='small'
                            >
                                <InputLabel htmlFor="API">API</InputLabel>
                                <Select
                                    size='small' fullWidth
                                    value={urlApi}
                                    onChange={onChangeSelectApi}
                                    label="API"
                                    inputProps={{
                                        name: 'API',
                                        id: 'API',
                                    }}
                                >
                                    {apiLocal && apiLocal.map((item, index) =>
                                        <MenuItem key={index + 's-' + item.nome} value={item.value}>{item.nome}</MenuItem>
                                    )}
                                </Select>

                            </FormControl>
                            
                            <IconButton
                                aria-label="toggle password visibility"
                                edge="end"
                                color={urlApi && urlApi.length > 0 ? 'primary' : 'inherit'}
                                onClick={handleSeeAPI}
                            >
                                <Visibility />
                            </IconButton>
                        </Stack>
                    }
                </Stack>
                {interno &&
                    <TextField sx={{ mt: 2, ml: 1 }}
                        label="Query parameter:" fullWidth
                        size='small' autoComplete="off"
                        // variant="outlined"
                        value={uri || ""}
                        onChange={(e) => setURI(e.target.value)}
                    />}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1} >
                    <Grid size={12}>
                        <TextField sx={{ mt: '6px' }}
                            label="Caminho dos dados"
                            size='small'
                            fullWidth value={caminho || ''} onChange={(e) => setCaminho(e.target.value)}
                            helperText="Noção JavaScript: campo.arr[0].nome"
                            slotProps={{
                                input: {
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <Tooltip title="Inferir do resultado">
                                                <IconButton onClick={handleInferir}>
                                                    <Check />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment>,
                                },
                            }}
                        />
                    </Grid>
                    <Grid size={12}>
                        <MontaTipo />
                    </Grid>
                    <Grid size={12}>
                        <Box sx={{ mt: 2 }}></Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button disabled={!urlApi|| urlApi.length < 3}
                    onClick={geraPagina}
                >Criar</Button>
            </DialogActions>

            <TrapFocus open disableAutoFocus disableEnforceFocus>
                <Fade appear={false} in={bannerOpen}>
                    <Paper
                        role="dialog"
                        aria-modal="false"
                        aria-label="Cookie banner"
                        square
                        variant="outlined"
                        tabIndex={-1}
                        sx={{
                            position: 'fixed',
                            top: 0,
                            bottom: 0,
                            left: "80%",
                            right: 0,
                            m: 0,
                            p: 2,
                            borderWidth: 0,
                            borderTopWidth: 1,
                            overflow: 'auto'
                        }}
                    >
                        <pre style={{
                            fontFamily: "cursive",
                            fontStyle: "italic",
                            fontSize: "12px"
                        }}>
                            {jsonTxt}
                        </pre>
                    </Paper>
                </Fade>
            </TrapFocus>
            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
        </Dialog>
    );
}